/**
 * `GET /v0/goods/popular-today` — the segmented home block.
 *
 * THREE SEGMENTS ANONYMOUS, FOUR SIGNED IN. The fourth (`for_you`) is built
 * from the shopper's taste profile and simply absent when she has none; the
 * response also carries `personalized`, so the section never has to guess
 * whether taste reached the query.
 *
 * THE TAB GOES AS `audience`, which is the word `helpers/audience`
 * canonicalises to and the one the backend reads. It used to declare only
 * `gender`: FastAPI drops a parameter no route declares, so `?audience=man`
 * and `?audience=woman` returned the same 32 products. Both spellings are read
 * now; this sends the canonical one.
 *
 * The response is snake_case by design — `goods/` is on the case transformer's
 * exclusion list, like every other endpoint serving product cards.
 */

import { apiClient } from '@/api/api'

export interface PopularTodayProduct {
  product_id: number
  product_variant_id: number
  product_group_id?: number
  brand_name: string
  product_name: string
  brand_id?: number
  color?: string
  currency?: string
  min_price?: number
  max_price?: number
  is_new_collection?: boolean
  main_image_url?: string | null
  image_urls?: string[] | null
}

export interface PopularTodaySegment {
  id: string
  title: string
  title_ru?: string
  reason?: string
  products: PopularTodayProduct[]
}

export interface PopularTodayResponse {
  segments: PopularTodaySegment[]
  generated_at?: string
  personalized?: boolean
}

export const getPopularToday = async (audience?: string) => {
  return apiClient.get<PopularTodayResponse>('/goods/popular-today', {
    params: {
      // omitted rather than sent empty: no tab means adults of every audience,
      // and `audience=` would be a tab named nothing
      ...(audience ? { audience } : {}),
    },
  })
}
